module.exports = __webpack_public_path__ + "img/documentsactive.3d563110.svg";